/**
 * URL puliti SEO e link interni.
 * Keyword principale: "creare qr code gratis"
 * Titoli e descrizioni per ogni pagina: vedi seo-pages.ts (PAGE_SEO).
 */
export const SEO_ROUTES = {
  home: "/",
  generator: "/creare-qr-code-gratis",
  whatsapp: "/qr-code-whatsapp",
  wifi: "/qr-code-wifi",
  instagram: "/qr-code-instagram",
  pdf: "/qr-code-pdf",
  menuRistorante: "/qr-code-menu-ristorante",
  cosEUnQrCode: "/cos-e-un-qr-code",
  qrCodeDinamicoVsStatico: "/qr-code-dinamico-vs-statico",
  qrCodeConLogo: "/come-creare-qr-code-con-logo",
  qrCodeBigliettiDaVisita: "/qr-code-biglietti-da-visita",
  qrCodeEventi: "/qr-code-eventi",
} as const;

export type SeoRouteKey = keyof typeof SEO_ROUTES;
